let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("27Pvu")).then(() => parcelRequire('eRIoN'));